import React from 'react';

import { Redirect, Route } from 'react-router-dom';

import { useCurrentUser } from 'providers/user/UserContext';


/**
 * Returns true if the profile has enough name/identity data to be
 * considered a "full" existing account.  Supports three shapes that
 * appear in production Firestore docs:
 *   1. data.name.first  – set by the profile-completion form
 *   2. data.displayName – set by some OAuth / legacy flows
 *   3. data.firstName   – set by older sign-up code
 * Falls back to checking that the profile has a non-empty `type`,
 * which is always written at account creation, so existing members
 * with sparse profiles are never falsely treated as anonymous.
 */
function hasName(data) {
    if (!data) return false;
    if (data.name && data.name.first && data.name.first.length > 0) return true;
    if (data.displayName && data.displayName.trim().length > 0) return true;
    if (data.firstName && data.firstName.trim().length > 0) return true;
    // Any profile with a type is a real, created account
    return typeof data.type === 'string' && data.type.length > 0;
}

export default function UnauthRoute({ children, ...rest }) {

    const { loading, data } = useCurrentUser();

    const render = ({ location }) => {
        // Wait for auth state to resolve before making routing decisions.
        if (loading) {
            return null;
        }

        if (data && hasName(data) && (data.type === 'athlete' || data.verified === true)) {
            return (
                <Redirect
                    to={{
                        pathname: "/dashboard",
                        state: { from: location }
                    }}
                />
            );

        } else if (data && hasName(data)) {
            return (
                <Redirect
                    to={{
                        pathname: "/explore",
                        state: { from: location }
                    }}
                />
            );
        } else if (data) {
            // Profile exists but has no name yet — send to profile completion
            return (
                <Redirect
                    to={{
                        pathname: "/profile",
                        state: { from: location }
                    }}
                />
            );
        } else {
            return (
                children
            )
        }
    };

    return (
        <Route
            {...rest}
            render={render}
        />
    );
};